<template>
  <div class="bootstrap-wrapper">
    <div class="container pl-0 pr-0" v-if="userData">
      <div class="row mt-5">
        <div class="col-md-8">
          <div class="row">
            <div class="col">
              <unicon name="file-check-alt" :fill="secCol"></unicon>
              <span class="text-barlow-condensed subtitle text-dark">
                {{ title }}
              </span>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col">
              <!-- <span class="text-primary">
              <unicon name="award" :fill="secCol"></unicon>
              1er nivel
            </span> -->
              <span class="text-primary">
                <unicon name="university" :fill="secCol"></unicon>
                {{ userData.school.name }}
              </span>
              <span class="text-primary">
                <unicon name="graduation-hat" :fill="secCol"></unicon>
                {{ reports.courseName }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4 mt-3" v-if="dateFilter">
          <!-- <unicon name="schedule" :fill="secCol"></unicon>
          <span class="text-barlow-condensed subtitle text-dark">
            Filtrar Fecha
          </span> -->
          <DropSelect
            class="mt-2"
            v-bind="selectFecha"
            v-model="selectFecha.selected"
            :icon="'calender'"
            :zIndex="3"
          />
        </div>
      </div>
      <div class="row" v-if="selectFecha.selected == 3">
        <div class="col-md-8 mt-3" v-if="dateFilter">
          <template>
            <div class="row">
              <div class="col-md-6">
                <VueDatePicker v-model="initialDate" :color="secCol">
                  <template #activator="{ date }">
                    <DropSelect
                      :date="date"
                      :type="'datePicker'"
                      :supTitle="'Fecha inicial'"
                      :placeholder="'Seleccione el día'"
                      :icon="'schedule'"
                      :zIndex="2"
                    />
                  </template>
                </VueDatePicker>
              </div>

              <div class="col-md-6">
                <VueDatePicker
                  v-model="endDate"
                  :color="secCol"
                  v-if="initialDate"
                >
                  <template #activator="{ date }">
                    <DropSelect
                      :date="date"
                      :type="'datePicker'"
                      :supTitle="'Fecha final'"
                      :placeholder="'Seleccione el día'"
                      :icon="'schedule'"
                    />
                  </template>
                </VueDatePicker>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import DropSelect from "@/components/DropSelect";

export default {
  name: "HeaderReport",
  components: {
    DropSelect,
  },
  data() {
    let { secCol } = this.$store.getters;

    return {
      secCol,
      initialDate: null,
      endDate: null,
      selectFecha: {
        id: "fecha",
        supTitle: "Fecha",
        placeholder: "Seleccione período",
        selected: "",
        options: [
          {
            text: "Mes actual",
            value: "1",
          },
          {
            text: "Últimos 30 días",
            value: "2",
          },
          {
            text: "Seleccionar rango de fechas",
            value: "3",
          },
        ],
      },
    };
  },
  props: {
    title: {},
    dateFilter: {
      default: true,
    },
  },
  computed: {
    ...mapState(["reports", "userData"]),
  },
  methods: {
    ...mapMutations(["setDateFilter", "setDate"]),
  },
  mounted() {
    this.selectFecha.selected = this.reports.dateFilterVal;
    this.initialDate = this.reports.initialDate;
    this.endDate = this.reports.endDate;
  },
  watch: {
    "selectFecha.selected"(newVal) {
      this.setDateFilter(newVal);
    },
    initialDate(newVal, oldVal) {
      if (!newVal) return;
      if (newVal == oldVal) return;

      if (this.endDate) {
        let initialDate = new Date(newVal);
        let endDate = new Date(this.endDate);

        if (endDate <= initialDate) {
          this.$notify({
            title: [
              "Fecha incorrecta",
              "La fecha inicial no puede ser mayor a la fecha final",
            ],
            type: "danger",
          });
          this.initialDate = oldVal;
          return;
        }
      }

      this.setDate({
        initialDate: newVal,
        endDate: this.endDate,
      });
    },
    endDate(newVal, oldVal) {
      if (!newVal) return;
      if (newVal == oldVal) return;

      if (this.initialDate) {
        let initialDate = new Date(this.initialDate);
        let endDate = new Date(newVal);

        if (endDate <= initialDate) {
          this.$notify({
            title: [
              "Fecha incorrecta",
              "La fecha final no puede ser menor a la fecha inicial",
            ],
            type: "danger",
          });
          this.endDate = oldVal;
          return;
        }
      }

      this.setDate({
        initialDate: this.initialDate,
        endDate: newVal,
      });
    },
  },
};
</script>
